var map = {
	"./aparthotelclub/ic_tag_venue.png": 40060,
	"./beachful/ic_tag_venue.png": 53925,
	"./castlepedia/ic_tag_venue.png": 44691,
	"./cocktayl/ic_tag_venue.png": 10581,
	"./ic_tag_venue.png": 10518,
	"./luxresortclub/ic_tag_venue.png": 54818,
	"./parkful/ic_tag_venue.png": 44251,
	"./prefabworld/ic_tag_venue.png": 68733,
	"./rooftopclub/ic_tag_venue.png": 97914,
	"./spaclub/ic_tag_venue.png": 55785,
	"./worldcasino/ic_tag_venue.png": 3317,
	"./zoopedia/ic_tag_venue.png": 62861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8544;